/* eslint-disable no-unused-vars */
import ActiveModules from './mock/ActiveModules.json';
import bbbEnabled from './mock/bbbEnabled.json';
import BookmarkSet from './mock/BookmarkSet.json';
import Catalogs from './mock/Catalogs.json';
import Categories from './mock/Categories.json';
import CategoryMediaGet from './mock/CategoryMediaGet.json';
import CheckEventTutor from './mock/CheckEventTutor.json';
import Common from './mock/Courses/Common.json';
import CommentList from './mock/CommentList.json';
import CommentVisibility from './mock/CommentVisibility.json';
import CommentSuccess from './mock/CommentSuccess.json';
import CompletedCourses from './mock/Courses/Completed.json';
import CotutorsList from './mock/CotutorsList.json';
import CDComplete from './mock/CourseDetails/Complete.json';
import CDCompleteWithSurvey from './mock/CourseDetails/CompleteWithSurvey.json';
import CDIncomplete from './mock/CourseDetails/Incomplete.json';
import CDModule from './mock/CourseDetails/Module.json';
import CDEvent from './mock/CourseDetails/Event.json';
import CourseActivities from './mock/CourseActivities.json';
import CourseUsers from './mock/CourseUsers.json';
import CourseUsersActivities from './mock/CourseUsersActivities.json';
import CourseCreate from './mock/CourseCreate.json';
import CourseRecommend from './mock/CourseRecommend.json';
import CourseStats from './mock/CourseStats.json';
import CreateDocument from './mock/CreateDocument.json';
import DashboardMock from './mock/DashboardMock.json';
import DocumentDetails from './mock/DocumentDetails.json';
import DocumentCategories from './mock/DocumentCategories.json';
import DocumentsList from './mock/DocumentsList.json';
import DocumentExpertDetails from './mock/DocumentExpertDetails.json';
import DocumentExpertCategories from './mock/DocumentExpertCategories.json';
import DocumentsExpertList from './mock/DocumentsExpertList.json';
import EditableCourseList from './mock/EditableCourseList.json';
import EmailNotification from './mock/EmailNotification.json';
import EventDates from './mock/EventDates.json';
import EventDetails from './mock/EventDetails.json';
import EventsList from './mock/EventsList.json';
import Faq from './mock/Faq.json';
import Ffoo from './mock/Ffoo.json';
import GroupAdd from './mock/GroupAdd.json';
import GroupList from './mock/GroupList.json';
import HomeCourses from './mock/Courses/Home.json';
import HomeConfiguration from './mock/HomeConfiguration.json';
import JoinBBBSession from './mock/JoinBBBSession.json';
import Levels from './mock/Levels.json';
import LoginMock from './mock/Autentication/Login.json';
import LoginOTP from './mock/Autentication/LoginOTP.json';
import Logo from './mock/Logo.json';
import MyCourses from './mock/MyCourses.json';
import MyCourses_2 from './mock/MyCourses_2.json';
import MyUsers from './mock/MyUsers.json';
import Modules from './mock/Courses/Modules.json';
import NewsDetails from './mock/NewsDetails.json';
import NewsList from './mock/NewsList.json';
import NewsListHome from './mock/NewsListHome.json';
import Newsletter from './mock/Newsletter.json';
import NewsletterBaseTemplate from './mock/NewsletterBaseTemplate.json';
import NewsletterDetails from './mock/NewsletterDetails.json';
import NotificationDetails from './mock/NotificationDetails.json';
import ProviderSSOList from './mock/ProviderSSOList.json';
import PublicData from './mock/PublicData.json';
import PublicHome from './mock/PublicHome.json';
import PublicPage from './mock/PublicPage.json';
import QuizAnswers from './mock/QuizAnswers.json';
import QuizDetails from './mock/QuizDetails.json';
import RefreshToken from './mock/Autentication/RefreshToken.json';
import RestorePasswordMock from './mock/restorePassword.json';
import RetrieveUserNotification from './mock/RetrieveUserNotification.json';
import ScormDetails from './mock/ScormDetails.json';
import ScormList from './mock/ScormList.json';
import SessionsList from './mock/SessionsList.json';
import SessionResultUsers from './mock/SessionResultUsers.json';
import SessionUsers from './mock/SessionUsers.json';
import StatsUserList from './mock/StatsUserList.json';
import SurveyAnswers from './mock/SurveyAnswers.json';
import SurveyFreeTextMock from './mock/SurveyFreeTextMock.json';
import SurveyStatsMock from './mock/SurveyStatsMock.json';
import SurveyQuestions from './mock/SurveyQuestions.json';
import Success from './mock/Success.json';
import UpdateSuccess from './mock/UpdateSuccess.json';
import SupportMail from './mock/SupportMail.json';
import TagList from './mock/TagList.json';
import SurveyList from './mock/SurveyList.json';
import TutorsList from './mock/TutorsList.json';
import UpdateCourseGET from './mock/UpdateCourseGET.json';
import UpdateEventGET from './mock/UpdateEventGET.json';
import UsefulLinks from './mock/UsefulLinks.json';
import UserCourses from './mock/UserCourses.json';
import UserGroups from './mock/UserGroups.json';
import UserInfoMock from './mock/User/InfoUser.json';
import UserList from './mock/UserList.json';
import UsersBySession from './mock/UsersBySession.json';
import UserStats from './mock/UserStats.json';
import CourseCreatedList from './mock/CourseCreatedList.json';
import Vocabulary from './mock/string.json';
import { parseQueryParams } from '../../utils/queryParams';
import RegionProvinceList from './mock/RegionProvinceList.json';
import AccessStatisticsList from './mock/SupervisorStats/AccessStatisticsList.json';
import ActivityStatisticsList from './mock/SupervisorStats/ActivityStatisticsList.json';
import ActivityList from './mock/SupervisorStats/ActivityList.json';
import CategoryStatisticsList from './mock/SupervisorStats/CategoryStatisticsList.json';
import CategoryList from './mock/SupervisorStats/CategoryList.json';
import TutorStatisticsList from './mock/SupervisorStats/TutorStatisticsList.json';
import TutorList from './mock/SupervisorStats/TutorList.json';
import CourseStatisticsList from './mock/SupervisorStats/CourseStatisticsList.json';
import LogsList from './mock/SupervisorStats/LogsList.json';
import CacheInvalidate from './mock/SupervisorStats/CacheInvalidate.json';
import LastCacheInvalidate from './mock/SupervisorStats/LastCacheInvalidate.json';

const getRandomNumber = (min = 0, max = 20) =>
  Math.floor(Math.random() * (max - min) + min);

const noDelay = 0;
const fastDelay = getRandomNumber(100, 500);
const normalDelay = getRandomNumber(200, 2000);
const slowDelay = getRandomNumber(1000, 3000);

export const getBaseResponse = (
  { data = 'ok', code = 200, result = true, pager } = {},
  delay = fastDelay
) =>
  new Promise((res) => {
    setTimeout(() => {
      res({ data: { data, pager } }, code, result);
    }, delay);
  });

// Puzzle mocks
export const getVocabularyMock = () => getBaseResponse(Vocabulary, 0);
export const getLoginMock = () => getBaseResponse(LoginMock);
export const getOTPLoginMock = () => getBaseResponse(LoginOTP);
export const refreshTokenMock = () => getBaseResponse(RefreshToken);
export const getUserInfoMock = () => getBaseResponse(UserInfoMock);
export const getCoursesMock = (filters) => {
  // console.log('filters', filters);
  if (filters?.completion_status === 'completed') {
    return getBaseResponse(CompletedCourses);
  }
  if (filters?.is_module) return getBaseResponse(Modules);
  return getBaseResponse(Common);
};
export const getHomeCoursesMock = () => getBaseResponse(HomeCourses);
export const getCatalogsMock = () => getBaseResponse(Catalogs);
export const getCategoriesMock = () => getBaseResponse(Categories);
export const getlevelsMock = () => getBaseResponse(Levels);
export const getFfooMock = () => getBaseResponse(Ffoo);
// export const getCourseDetailMock = () => getBaseResponse(CDComplete);
export const getCourseDetailMock = () => getBaseResponse(CDCompleteWithSurvey);
// export const getCourseDetailMock = () => getBaseResponse(CDIncomplete);
// export const getCourseDetailMock = () => getBaseResponse(CDModule);
// export const getCourseDetailMock = () => getBaseResponse(CDEvent);

export const setBookmarkMock = () => getBaseResponse(BookmarkSet);
export const successMock = () => getBaseResponse(Success);
export const updateSuccessMock = () => getBaseResponse(UpdateSuccess);
export const getCommentListMock = () => getBaseResponse(CommentList);
export const commentVisibilityMock = () => getBaseResponse(CommentVisibility);
export const commentSuccessMock = () => getBaseResponse(CommentSuccess);
export const quizAnswersMock = () => getBaseResponse(QuizAnswers);
export const getEventDatessMock = () => getBaseResponse(EventDates);
export const getEventsListMock = () => getBaseResponse(EventsList);
export const getSessionsListMock = () => getBaseResponse(SessionsList);
export const getEventDetailsMock = () => getBaseResponse(EventDetails);
export const joinBBBSessionMock = () => getBaseResponse(JoinBBBSession);
export const bbbEnabledMock = () => getBaseResponse(bbbEnabled);
export const bbbUrlMock = () => getBaseResponse(JoinBBBSession);
export const dashboardInfoMock = () => getBaseResponse(DashboardMock);
export const getHomeConfigurationMock = () =>
  getBaseResponse(HomeConfiguration);
export const getNotificationMock = (filters) =>
  // console.log('### getNotifications ###', filters);
  getBaseResponse(RetrieveUserNotification);
export const getNotificationDetailsMock = () =>
  getBaseResponse(NotificationDetails);
export const readNotificationMock = () => getBaseResponse(Success);
export const deleteNotificationMock = () => getBaseResponse(Success);
export const surveyQuestionsMock = () => getBaseResponse(SurveyQuestions, 0);
export const surveyAnswersMock = () => getBaseResponse(SurveyAnswers);
export const emailNotificationMock = () => getBaseResponse(EmailNotification);
export const getFaqMock = () => getBaseResponse(Faq);
export const getLogoMock = () => getBaseResponse(Logo);
export const restorePasswordMock = () => getBaseResponse(RestorePasswordMock);
export const publicDataMock = () => getBaseResponse(PublicData);
export const publicPageMock = (id) => {
  if (id === '37') return getBaseResponse(PublicHome);
  return getBaseResponse(PublicPage);
};
export const newsDetailsMock = () => getBaseResponse(NewsDetails);
export const newsListMock = () => getBaseResponse(NewsList);
export const newsListHomeMock = () => getBaseResponse(NewsListHome);
export const tutorsListMock = () => getBaseResponse(TutorsList);
export const cotutorsListMock = () => getBaseResponse(CotutorsList);
export const activeModulesMock = () => getBaseResponse(ActiveModules);
export const getUsersBySessionMock = () => getBaseResponse(UsersBySession);
export const checkEventTutorMock = () => getBaseResponse(CheckEventTutor);
export const documentDetailsMock = () => getBaseResponse(DocumentDetails);
export const documentsListMock = () => getBaseResponse(DocumentsList);
export const documentCategoriesMock = () => getBaseResponse(DocumentCategories);
export const documentExpertDetailsMock = () =>
  getBaseResponse(DocumentExpertDetails);
export const documentsExpertListMock = () =>
  getBaseResponse(DocumentsExpertList);
export const documentExpertCategoriesMock = () =>
  getBaseResponse(DocumentExpertCategories);
export const newsletterGetMock = () => getBaseResponse(Newsletter);
export const newsletterDetailsMock = () => getBaseResponse(NewsletterDetails);
export const getProviderSSOList = () => getBaseResponse(ProviderSSOList);
export const usefulLinksGetMock = () => getBaseResponse(UsefulLinks);
export const courseRecommendMock = () => getBaseResponse(CourseRecommend);
export const SupportMailGetMock = () => getBaseResponse(SupportMail);
export const userListGetMock = () => getBaseResponse(UserList);
export const groupListGetMock = () => getBaseResponse(GroupList);
export const addGroupMock = () => getBaseResponse(GroupAdd);
export const scormListGetMock = () => getBaseResponse(ScormList);
export const scormDetailsGetMock = () => getBaseResponse(ScormDetails);
export const tagListGetMock = () => getBaseResponse(TagList);
export const surveyListGetMock = () => getBaseResponse(SurveyList);
export const courseCreateMock = () => getBaseResponse(CourseCreate);
export const regionProvinceListMock = () => getBaseResponse(RegionProvinceList);

//quiz create
let quizId = 0;
export const quizcreateMock = () => {
  quizId += 1;
  return getBaseResponse({ data: { id: quizId } });
};
export const quizDetailsMock = () => getBaseResponse(QuizDetails);

export const updateCourseDetailsGetMock = () =>
  // getBaseResponse(UpdateCourseGET);
  getBaseResponse(UpdateEventGET);

export const tutorCourseListGetMock = () => getBaseResponse(EditableCourseList);

//statistics
export const getUserListMock = () => getBaseResponse(StatsUserList);
export const getUserStatsMock = () => getBaseResponse(UserStats);
export const getUserCoursesMock = () => getBaseResponse(UserCourses);
export const getUserGroupsMock = () => getBaseResponse(UserGroups);
export const getCourseStatsMock = () => getBaseResponse(CourseStats);
export const getCourseActivitiesMock = () => getBaseResponse(CourseActivities);
export const getCourseUsersMock = () => getBaseResponse(CourseUsers);
export const getCourseUsersActivitiesMock = () =>
  getBaseResponse(CourseUsersActivities);
export const getMyGroupsMock = () => getBaseResponse(CourseStats);
export const getGroupCoursesMock = () => getBaseResponse(EditableCourseList);
export const getMyCoursesMock = (year) => {
  if (year % 2 === 0) return getBaseResponse(MyCourses);
  return getBaseResponse(MyCourses_2);
};
export const getMyUsersMock = () => getBaseResponse(MyUsers);
export const getCourseCreatedListMock = () =>
  getBaseResponse(CourseCreatedList);
export const getSurveyStatsMock = () => getBaseResponse(SurveyStatsMock);
export const getSurveyFreeTextMock = () => getBaseResponse(SurveyFreeTextMock);
export const createDocumentMock = () => getBaseResponse(CreateDocument);
// category media
export const getCategoryMediaMock = () => getBaseResponse(CategoryMediaGet);
//liveEvents
export const sessionUsersGetMock = () => getBaseResponse(SessionUsers);
export const sessionResultGetMock = () => getBaseResponse(SessionResultUsers);
//supervisorStats
export const getAccessStatisticsListMock = () =>
  getBaseResponse(AccessStatisticsList);
export const getActivityStatisticsListMock = () =>
  getBaseResponse(ActivityStatisticsList);
export const getActivityListMock = () => getBaseResponse(ActivityList);
export const getCategoryStatisticsListMock = () =>
  getBaseResponse(CategoryStatisticsList);
export const getCategoryListMock = () => getBaseResponse(CategoryList);
export const getTutorStatisticsListMock = () =>
  getBaseResponse(TutorStatisticsList);
export const getTutorListMock = () => getBaseResponse(TutorList);
export const getCourseStatisticsListMock = () =>
  getBaseResponse(CourseStatisticsList);
export const getLogsListMock = () => getBaseResponse(LogsList);
export const getCacheInvalidateMock = () => getBaseResponse(CacheInvalidate);
export const getLastCacheInvalidateMock = () =>
  getBaseResponse(LastCacheInvalidate);
export const getNewsletterBaseTemplateMock = () =>
  getBaseResponse(NewsletterBaseTemplate);
